<script setup>
function onInteract() {
  document.dispatchEvent(new CustomEvent("Interact", { detail: true }));
}
</script>

<template>
  <button class="mobile-action"  @click="onInteract">
    <span class="mobile-action__blue">
      E
    </span>
  </button>
</template>

<style lang="scss" scoped>
.mobile-action {
  padding: 0.2rem;
  position: absolute;
  top: 200px;
  right: 100px;
  background-color: #ffffff4d;
  border-radius: 100%;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-in-out;

  &__blue {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #003099;
    opacity: 0.8;
    color: #fff;
  }
}
</style>